module.exports = __webpack_public_path__ + "img/qsht.eb1cbd2c.png";